import { BookDetailsPage } from '@/components/bookDetails';

export default function BookDetails() {
  return <BookDetailsPage />;
}
